/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CancellingInputs */

const en_orders_cancelling = /** @type {(inputs: Orders_CancellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelling...`)
};

const es_orders_cancelling = /** @type {(inputs: Orders_CancellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelando...`)
};

/**
* | output |
* | --- |
* | "Cancelling..." |
*
* @param {Orders_CancellingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancelling = /** @type {((inputs?: Orders_CancellingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CancellingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancelling(inputs)
	return es_orders_cancelling(inputs)
});